import { sync } from '@genesislcap/foundation-utils';
import { html, ref, repeat } from '@microsoft/fast-element';
import { closeIcon } from '../_common/icons';
import { getPrefix } from '../utils';
const closeIconTemplate = html `
  <div class="close-icon" @click=${(x) => x.clear()}>${closeIcon()}</div>
`;
const textFilterTemplate = (prefix) => html `
  <div class="flex-row">
    <div>${(x) => x.label}</div>
    ${closeIconTemplate}
  </div>
  <div class="flex-row">
    <${prefix}-text-field
      ${ref('textFilterField')}
      type="text"
      :value=${sync((x) => x.textFilter)}
    />
  </div>
`;
const numberFilterTemplate = (prefix) => html `
  <div class="flex-row">
    <div>${(x) => x.label}</div>
    ${closeIconTemplate}
  </div>
  <div class="flex-row">
    <${prefix}-text-field
      ${ref('numFilterFieldMin')}
      type="number"
      :value=${sync((x) => x.numFilterMin)}
      placeholder="min"
    ></${prefix}-text-field>
    <${prefix}-text-field
      ${ref('numFilterFieldMax')}
      type="number"
      :value=${sync((x) => x.numFilterMax)}
      placeholder="max"
    ></${prefix}-text-field>
  </div>
`;
const dateFilterTemplate = (prefix) => html `
  <div class="flex-row">
    <div>${(x) => x.label}</div>
    ${closeIconTemplate}
  </div>
  <div class="flex-row">
    <${prefix}-text-field
      ${ref('dateFilterFieldMin')}
      type="date"
      :value=${sync((x) => x.dateFilterMin)}
    ></${prefix}-text-field>
    <${prefix}-text-field
      ${ref('dateFilterFieldMax')}
      type="date"
      :value=${sync((x) => x.dateFilterMax)}
    ></${prefix}-text-field>
  </div>
`;
function targetValue(ctx) {
    var _a, _b, _c;
    return (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.event) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 'all';
}
const booleanFilterOptions = [
    { name: 'All', value: 'all', selected: true },
    { name: 'True', value: 'true' },
    { name: 'False', value: 'false' },
    { name: 'N/A', value: 'null' },
];
const booleanFilterTemplate = (prefix) => html `
  <div class="flex-row">
    <div>${(x) => x.label}</div>
    ${closeIconTemplate}
  </div>
  <div class="flex-row">
    <${prefix}-select @change="${(x, c) => x.onBooleanFilterSelection(targetValue(c))}}">
      ${repeat(() => booleanFilterOptions, html `
          <${prefix}-option value="${(x) => x.value}" selected="${(x) => x.selected}">
            ${(x) => x.name}
          </${prefix}-option>
        `)}
    </${prefix}-select>
  </div>
`;
const enumFilterTemplate = (prefix) => html `
  <div class="flex-row">
    <div>${(x) => x.label}</div>
    ${closeIconTemplate}
  </div>
  <div class="flex-row">
    <${prefix}-select @change="${(x, c) => x.onEnumFilterSelection(targetValue(c))}}">
      ${repeat((x) => x.enumFilterOptions, html `
          <${prefix}-option value="${(x) => x.value}" selected="${(x) => x.selected}">
            ${(x) => x.name}
          </${prefix}-option>
        `)}
    </${prefix}-select>
  </div>
`;
const selectTemplate = (x, prefix) => {
    switch (x.type) {
        case 'number':
            return numberFilterTemplate(prefix);
        case 'date':
            return dateFilterTemplate(prefix);
        case 'boolean':
            return booleanFilterTemplate(prefix);
        case 'enum':
            return enumFilterTemplate(prefix);
        default:
            return textFilterTemplate(prefix);
    }
};
export const getPrefixedFilterTemplate = (prefix) => html `
  <div class="filter-wrapper">${(x) => selectTemplate(x, prefix)}</div>
`;
export const foundationFilterTemplate = html `
  ${(x) => getPrefixedFilterTemplate(getPrefix(x))}</div>
`;
